// FIXME: remove after nuxtjs/supabase installed
import { createClient } from '@supabase/supabase-js'
import { createCustomFetch } from '@workspace/utils/createCustomFetch'
import defu from 'defu'

export const createSupabaseClient = () => {
  const {
    supabase: { url, key, client: clientOptions },
  } = useRuntimeConfig().public

  // Set auth options to fix https://github.com/supabase/gotrue-js/issues/539
  const auth = {
    detectSessionInUrl: import.meta.server ? false : clientOptions.auth?.detectSessionInUrl,
    persistSession: import.meta.server ? false : clientOptions.auth?.persistSession,
    autoRefreshToken: import.meta.server ? false : clientOptions.auth?.autoRefreshToken,
  }

  const customFetch = createCustomFetch({
    retryEnabled: true,
  })

  return createClient(
    url,
    key,
    defu(
      {
        auth, // set auth header
        global: {
          fetch: customFetch,
        },
      },
      clientOptions
    )
  )
}
